import script from "./DomainEventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainEventCard.vue?vue&type=script&setup=true&lang=js"

import "./DomainEventCard.vue?vue&type=style&index=0&id=6ee84130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee84130"]])

export default __exports__